module.exports = "<mat-tab #tab [label]=\"label\" disabled>\r\n    <ng-content></ng-content>\r\n</mat-tab>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/crew-wizard-tab.component.html
// module id = 1252
// module chunks = 1